










// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/piscine/edit/EditTemplateCours.vue'
import TemplateCoursItem from '@/components/administration/piscine/read/TemplateCoursItem.vue'
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine'
import { getImageUrl } from '@/utils/images'

@Component({
  name: 'ReadTemplateCours',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,TemplateCoursItem}
})
export default class ReadTemplateCours extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean

  get cours(){
    return this.piscine.templateCours
  }

  get getImageUrl(){
    return getImageUrl
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  get configuration(){    
    return this.$store.myGetters.configuration
  }

  created(){
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

  edit() { (this.$refs.edit as Edit).edit(this.piscine) }
}
